// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__PXADV","head":"ProcedureTableInfo_head__2ZPO_"};